export default "__VITE_ASSET__7daade09__"